import { useState } from 'react';
import { columnGroups } from '@/mocks/homeData';

const slotKeys = Object.keys(columnGroups);

const slotTone: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-900',
  secondary: 'bg-secondary-100 text-secondary-900',
};

export default function Columns() {
  const [key, setKey] = useState(slotKeys[1]);
  const group = columnGroups[key];

  return (
    <section id="columns" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
          <div className="max-w-2xl">
            <span className="text-sm font-semibold tracking-widest text-primary-600">专题阅读</span>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              栏目专区<span className="text-primary-600">按点深读</span>
            </h2>
            <p className="mt-3 text-base text-foreground-600 md:text-lg">
              时间表之外的长文栏目。定档怎么看、名场面怎么来的、热度怎么衡量，都在这里拆开讲。
            </p>
          </div>
          <a
            href="#subscribe"
            onClick={(e) => { e.preventDefault(); document.getElementById('subscribe')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition hover:border-primary-400 hover:bg-primary-50 hover:text-primary-700"
          >
            订阅新栏目
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        {/* slot tabs */}
        <div className="mt-8 flex gap-2 overflow-x-auto pb-2">
          {slotKeys.map((k) => {
            const cg = columnGroups[k];
            const isActive = k === key;
            return (
              <button
                key={k}
                type="button"
                onClick={() => setKey(k)}
                className={`flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full px-4 py-2 text-sm transition md:px-5 ${
                  isActive
                    ? 'bg-primary-500 text-background-50 shadow-md shadow-primary-500/20'
                    : 'border border-background-300 bg-background-100/60 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
                }`}
              >
                <i className={`${isActive ? 'ri-radio-button-fill' : 'ri-radio-button-line'}`} />
                {cg.name.split(' · ')[0]}
              </button>
            );
          })}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-2">
          {group.items.map((card) => (
            <article
              key={card.id}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:border-primary-200 sm:flex-row"
            >
              <div className="relative h-52 w-full shrink-0 overflow-hidden sm:h-auto sm:w-56 md:w-64">
                <img
                  src={card.img}
                  alt={card.title}
                  title={`${card.title}`}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span className={`absolute left-3 top-3 rounded-full px-3 py-1 text-xs font-medium ${slotTone[card.slotTone]}`}>
                  {card.slot}
                </span>
              </div>
              <div className="flex flex-1 flex-col justify-center p-5 md:p-6">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-900 transition group-hover:text-primary-700 md:text-xl">
                  {card.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{card.lead}</p>
                <div className="mt-4 flex items-center gap-4 text-xs text-foreground-400">
                  <span className="inline-flex items-center gap-1"><i className="ri-eye-line" />{card.reads} 阅读</span>
                  <span className="inline-flex items-center gap-1"><i className="ri-time-line" />约 {card.minutes} 分钟</span>
                  <span className="ml-auto inline-flex items-center gap-1 text-primary-600 transition group-hover:gap-2">
                    继续阅读<i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}